module.exports = __webpack_public_path__ + "img/under-construction-pana.004f2267.png";